import React, { useContext, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./index.css";
import DoctaAiChat from "../../DoctaAiTest/DoctaAiChat";
import MyContext from "../Mycontext";

const ChatPage = () => {
	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}

	const { sessionId, recordList, setRecordList, hideSide, setHideSide } =
		context;

	return (
		<DoctaAiChat
			recordList={recordList}
			setRecordList={setRecordList}
			sessionId={sessionId}
			onHideSide={() => setHideSide(!hideSide)}
			hideSide={hideSide}
		/>
	);
};

export default ChatPage;
